import * as h2Api from '../../h2Api'
import * as profileActions from '../../actions/occupationProfile'
import { POPUP_JOURNAL_COMPLETION } from '../../actions/journals'
import { handleReducingJournalForItem } from '../../actions'

const initialState = {
  selectedProfile: null,
  selectedModal: null,
  selectedLocalTab: 0,
  localOpportunitiesLoading: false,
  interests: {
    '1.B.1.a': {
      name: 'Realistic',
      description:
        'People with Realistic interests like work activities that include practical, hands-on problems and answers. They like working with plants and animals, and real-world materials, like wood, tools, and machinery. They enjoy outside work.'
    },
    '1.B.1.b': {
      name: 'Investigative',
      description:
        'People with Investigative interests like work that has to do with ideas and thinking rather than physical activity or leading people. They like to search for facts and figure out problems.'
    },
    '1.B.1.c': {
      name: 'Artistic',
      description:
        'People with Artistic interests like work that deals with the artistic side of things, such as acting, music, art, and design. They like creativity in their work and work that can be done without following a set of rules.'
    },
    '1.B.1.d': {
      name: 'Social',
      description:
        'People with Social interests like working with others to help them learn and grow. They like working with people more than working with objects, machines, or information. They like teaching, giving advice, and helping and being of service to people.'
    },
    '1.B.1.e': {
      name: 'Enterprising',
      description:
        'People with Enterprising interests like work that has to do with starting up and carrying out business projects. These people like taking action rather than thinking about things. They like persuading and leading people, making decisions, and taking risks for profit.'
    },
    '1.B.1.f': {
      name: 'Conventional',
      description:
        'People with Conventional interests like work that follows set procedures and routines. They prefer working with information and paying attention to detail rather than working with ideas. They like working with clear rules and following a strong leader.'
    }
  }
}
const profile = (state = initialState, action) => {
  switch (action.type) {
    case profileActions.CLEAR_SELECTED:
      return initialState

    case profileActions.RATE_OCCUPATION:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result
        const { rating, ...itms } = state.selectedProfile.personalization

        return {
          ...state,
          selectedProfile: {
            ...state.selectedProfile,
            personalization: {
              ...itms,
              ...action.restCall.result
            }
          }
        }
      }

      return state

    case profileActions.SELECT_MODAL_OCCUPATION:
      return {
        ...state,
        selectedModal: action.modalName
      }

    case profileActions.SELECT_COMPARISON_REGION:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selectedProfile: {
            ...state.selectedProfile,
            comparisonWages: p.wages,
            comparisonOutlook: p.outlook
          }
        }
      }

      return state

    case profileActions.OCCUPATION_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selectedProfile: p
        }
      }

      return state

    case POPUP_JOURNAL_COMPLETION:
      return handleReducingJournalForItem(action, state, 'selectedProfile')

    case profileActions.LOCAL_LOADING:
      return {
        ...state,
        localOpportunitiesLoading: true
      }

    case profileActions.LOCAL_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selectedLocalTab: action.selectedLocalTab,
          localOpportunitiesLoading: false,
          selectedProfile: {
            ...state.selectedProfile,
            localOpportunities: p
          }
        }
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.ERROR) {
        return {
          ...state,
          localOpportunitiesLoading: false
        }
      }

      return state

    default:
      return state
  }
}

export default profile
